var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markets-switcher"},[_c('ToggleSwitcher',{attrs:{"model":_vm.toggled},on:{"change":e => _vm.toggled= !_vm.toggled}}),_c('TextSimple',{attrs:{"size":"m","weight":"bold"}},[_vm._v(_vm._s(_vm.$t(`countries_code.${_vm.text}`)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }